import React, { Component } from "react";
import { GA_Push } from "../Services/Analytics"

import "./Header.scss"
import { mobile } from "../Services/Agent";

class Header extends Component {
  constructor() {
    super()
    this.state = {
      showShareOptions: false,
      isScrolled: false
    }
    this.shareBTN = this.shareBTN.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isScrolled: (window.scrollY > 0.10 * window.screen.width ? true : false)
      })
    })
  }
  shareBTN(action) {
    var metaTags = Array.from(window.document.getElementsByTagName("meta"));
    var urlToShare = metaTags.filter(x => x.attributes[0].value.includes("og:url"))[0].content + "?utm_source=" + (mobile() ? "m.ynet.co.il" : "ynet.co.il") + "&utm_medium=social";
    var textToShare = `${metaTags.filter(x => x.attributes[0].value.includes("og:description"))[0].content} >> ${urlToShare}`;

    switch (action) {
      default:
      case "facebook":
        GA_Push("Share_Events", "Share to Facebook", '' , "Social");
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(urlToShare), "_blank");
        break;
      case "whatsapp":
        GA_Push("Share_Events", "Share to Whatsapp", '' , "Social");
        if (mobile()) {
          window.open("whatsapp://send?text=" + encodeURIComponent(textToShare + "&utm_campaign=whatsapp"), "_parent");
        } else {
          window.open("https://web.whatsapp.com/send?phone=&text=" + encodeURIComponent(textToShare + "&utm_campaign=whatsapp"), "_blank");
        }
        break;
      case "negishut":
      //  GA_Push("Accessibility", "Open_Accessibility_Clicked");
        window.document.getElementById('INDmenu-btn').click();
        break;
      case "sharer":
        this.setState({
          showShareOptions: !this.state.showShareOptions
        })
        break;
    }
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className={`share${(this.state.showShareOptions ? " active" : "")}`}>
                <div onClick={() => { this.shareBTN("whatsapp") }} className="whatsapp"></div>
                <div onClick={() => { this.shareBTN("facebook") }} className="facebook"></div>
                <div onClick={() => { this.shareBTN("sharer") }} className="sharer"></div>
                <div onClick={() => { this.shareBTN("negishut") }} className="negishut"></div>
              </div>
              <div className="logos">
                <div className="bank"></div>
                <a href="https://ynet.co.il/" target="_blank"><div className="ynet"></div></a>
                <div className="yediot"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtual-header"></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx